// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.approveButton {
    
}

.approveButton:hover {
    cursor: pointer;
}

.rejectButton {
}

.rejectButton:hover {
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/pages/admin/components/AdminUserActions/AdminUserActions.css"],"names":[],"mappings":"AAAA;;AAEA;;AAEA;IACI,eAAe;AACnB;;AAEA;AACA;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".approveButton {\n    \n}\n\n.approveButton:hover {\n    cursor: pointer;\n}\n\n.rejectButton {\n}\n\n.rejectButton:hover {\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
